/*=========================================================================================
  File Name: moduleActivityGetter.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Teacher Getter
  Author: Samir Karmacharya
  Author URL:
==========================================================================================*/


export default {}
